import { render, staticRenderFns } from "./AllDictionary.vue?vue&type=template&id=39475f91&scoped=true&"
import script from "./AllDictionary.vue?vue&type=script&lang=js&"
export * from "./AllDictionary.vue?vue&type=script&lang=js&"
import style0 from "./AllDictionary.vue?vue&type=style&index=0&id=39475f91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39475f91",
  null
  
)

export default component.exports